import Vue from "vue";
import VueI18n from "vue-i18n";
import fa from "./locales/fa";
import ps from "./locales/ps";
import en from "./locales/en";

Vue.use(VueI18n);

// Hot updates
if (module.hot) {
  module.hot.accept(["./locales/fa", "./locales/ps"], function () {
    i18n.setLocaleMessage("ps", require("./locales/ps").default);
    i18n.setLocaleMessage("fa", require("./locales/fa").default);
    i18n.setLocaleMessage("en", require("./locales/en").default);
  });
}
export default new VueI18n({
  locale: "fa",
  fallbackLocale: "fa",
  messages: { fa, en }
});
